// Docs domain types — mirrors DocCategoryResource, DocArticleListItemResource,
// DocArticleResource, and the search-index flat payload from the backend.

export const DocCategory = {
  GettingStarted: 'getting-started',
  EventsEditions: 'events-editions',
  RegistrationForms: 'registration-forms',
  PricingDiscounts: 'pricing-discounts',
  ParticipantManagement: 'participant-management',
  PaymentsFinance: 'payments-finance',
  PublicEventWebsite: 'public-event-website',
  OrganisationSettings: 'organisation-settings',
  Newsletters: 'newsletters',
  ApiIntegrations: 'api-integrations',
} as const

export type DocCategory = typeof DocCategory[keyof typeof DocCategory]

export const DocCategoryValues: DocCategory[] = [
  DocCategory.GettingStarted,
  DocCategory.EventsEditions,
  DocCategory.RegistrationForms,
  DocCategory.PricingDiscounts,
  DocCategory.ParticipantManagement,
  DocCategory.PaymentsFinance,
  DocCategory.PublicEventWebsite,
  DocCategory.OrganisationSettings,
  DocCategory.Newsletters,
  DocCategory.ApiIntegrations,
]

export const DocArticleStatus = {
  Draft: 'draft',
  Published: 'published',
  Outdated: 'outdated',
} as const

export type DocArticleStatus = typeof DocArticleStatus[keyof typeof DocArticleStatus]

export interface DocCategorySummary {
  slug: DocCategory
  article_count: number
}

export interface DocHeading {
  id: string
  text: string
  level: 2 | 3
}

export interface DocArticleListItem {
  category: DocCategory
  slug: string
  locale: string
  title: string
  excerpt: string | null
  status: DocArticleStatus
  last_reviewed_at: string | null
  tags: string[]
}

export interface DocArticle extends DocArticleListItem {
  requested_locale?: string // present when a fallback to 'en' occurred
  body: string // Markdown source
  headings: DocHeading[]
}

export interface DocSearchEntry {
  id: number
  title: string
  category: DocCategory
  slug: string
  locale: string
  excerpt: string
  tags: string[]
  headings: string[]
  url: string
}

export interface DocSearchResult extends DocSearchEntry {
  score: number // relevance score, higher is better
}

export interface SubmitDocFeedbackPayload {
  helpful: boolean
  locale: string
}
